import { Component, Input, OnInit } from '@angular/core';
import { AppSettings } from 'app/modules/shared/app.settings';
import { displayTruncatedText } from 'app/modules/shared/utility-functions/helperFunctions';

@Component({
  selector: 'app-manage-shift-slot-card',
  templateUrl: './manage-shift-slot-card.component.html',
  styleUrls: ['./manage-shift-slot-card.component.scss']
})
export class ManageShiftSlotCardComponent implements OnInit {
  @Input() teamDetails: any;
  @Input() openShiftStatusList: any;
  openShiftStatusColors = AppSettings.OPEN_SHIFT_STATUS;
  teamName = '';
  istrim = false;

  constructor() { }

  ngOnInit(): void {
    this.teamName = this.displayTruncatedTextValue(this.teamDetails.teamName) ?? '';
    this.istrim = this.teamName.split('').length > 15;
  }

  getStatusLabelFromCode(statusCode: number) {
   const currentStatus = this.openShiftStatusList.find((status) => +(status.value) === statusCode );
   // NOTE: handled the case where if the status code is null then it'll by default show green color
   const currentStatusCode = currentStatus ? currentStatus.value : 820;
   return currentStatusCode;
  }

  displayTruncatedTextValue(value) {
    return displayTruncatedText(value, 15);
  }

}
